import React from "react";
import { array, string, object, bool } from "prop-types";
import get from "lodash/get";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";
import CustomStoryCard3 from "../../../molecules/CustomStoryCard3";
import { getKeyHighlights } from "../../../utils/utils";
import LiveBlogStoryCard from "../../../molecules/LiveBlogStoryCard";
import CardImage from "../../../atoms/CardImage";
import Headline from "../../../atoms/Headline";
import { Link } from "@quintype/components";
import StoryMetaData from "../../../molecules/StoryMetaData";
import DfpAd from "../../../dfp-ad";

import "./row1.m.css";

const Row1 = ({ stories, widgetUrl, collectionSlug, publisherAttributes, updatedFont = false, liveBlogStory }) => {
  const keyHighlights = liveBlogStory && getKeyHighlights(liveBlogStory.cards);

  const defaultSecondStoryCard = () => (
    <div styleName="card-with-widget">
      {stories.length > 1 && (
        <CustomStoryCard3
          story={stories[1].story}
          isExcerpt={true}
          isWidget={!!widgetUrl}
          updatedFont={true}
          publisherLang={publisherAttributes.lang}
          src="fourteen-stories-3ad-1-widget"
        />
      )}
      {widgetUrl && (
        <div styleName="placeholder sports-widget">
          <iframe src={widgetUrl} width="274" height="100" styleName="widget-iframe"></iframe>
        </div>
      )}
    </div>
  );

  const renderSecondStoryCard = () => {
    if (liveBlogStory) {
      return (
        <LiveBlogStoryCard
          story={liveBlogStory}
          keyHighlights={keyHighlights}
          updatedFont={true}
          publisherLang={publisherAttributes.lang}
        />
      );
    } else {
      return defaultSecondStoryCard();
    }
  };

  let heroImage = "";
  if (get(stories[0].story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"])) {
    heroImage = stories[0].story.alternative.home.default["hero-image"]["hero-image-s3-key"];
  } else if (stories[0].story["hero-image-s3-key"]) {
    heroImage = stories[0].story["hero-image-s3-key"];
  }

  return (
    <div styleName={`base ${heroImage ? "" : "no-image"}`}>
      <div styleName="mobile-first-story-card">
        <Link href={stories[0].story.url}>
          <CardImage
            story={stories[0].story}
            imageType="image3x4"
            aspectRatio={[3, 4]}
            widths={[1200]}
            showAlternateImage={true}
          />
        </Link>
        <div styleName="story-data">
          {stories[0].story.subheadline ? (
            <Link href={stories[0].story.url}>
              <Headline
                text={stories[0].story.subheadline}
                headerLevel={3}
                className="subheadline"
                styleName={`${publisherAttributes.lang}-sub-headline`}
              />
            </Link>
          ) : null}
          <Link href={stories[0].story.url}>
            <Headline
              text={stories[0].story.headline}
              headerLevel={2}
              className="story-headline"
              styleName={`${publisherAttributes.lang}-story-headline-mobile-1`}
            />
          </Link>
          <StoryMetaData story={stories[0].story} updatedFont={true} publisherLang={publisherAttributes.lang} />
        </div>
      </div>
      <CustomStoryCard2
        story={stories[0].story}
        imageType="image3x2"
        aspectRatio={[3, 2]}
        isMetaDataShown={true}
        showHeroImage={!!heroImage}
        isTag={false}
        widths={[350]}
        isExcerpt={true}
        updatedFont={updatedFont}
        src="fourteen-stories-3ad-1-widget"
      />
      {stories[1] && renderSecondStoryCard()}
      <div styleName="adslots">
        <div styleName="placeholder ad-slot">
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="FourteenStories3Ad1Widget"
          />
        </div>
        {widgetUrl && (
          <div styleName="placeholder sports-widget">
            <iframe src={widgetUrl} width="300" height="100" styleName="widget-iframe"></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  widgetUrl: string,
  collectionSlug: string,
  publisherAttributes: object,
  updatedFont: bool,
  liveBlogStory: object
};

export default Row1;
